import { useSearchParams } from "react-router";
import { AuthForm } from "@/components/auth/auth-form";
import { ResetPasswordSkeleton } from "@/components/page-skeletons";
import { ViewFallback } from "@/components/page-states";
import { usePageTitle, useView } from "@shared/client/view";
import { useT } from "@shared/client/locale";

export default function ResetPasswordPage() {
  const t = useT();
  usePageTitle(t.auth.pageTitles.resetPassword);
  const [params] = useSearchParams();
  const token = params.get("token");
  // Sans jeton, le changement de mot de passe vise la session ouverte.
  const check = useView<{ valid: boolean }>(token ? `/api/auth/reset?token=${encodeURIComponent(token)}` : null);
  // Le lien se vérifie : le formulaire en squelette ; une vérification impossible (réseau, panne) se réessaie.
  if (token && !check.data) {
    return <ViewFallback error={check.error} placement="page" skeleton={<ResetPasswordSkeleton />} subject={t.auth.resetPassword.subject} />;
  }
  const valid = !token || check.data?.valid === true;
  return (
    <AuthForm
      initialError={valid ? "" : t.auth.resetPassword.invalidLink}
      mode="reset"
      resetToken={token}
    />
  );
}
